import React, { useEffect, useState } from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import {
  Box,
  Grid,
  makeStyles,
  Button,
  TextField,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@material-ui/core/";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from "@material-ui/icons/Edit";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import CancelIcon from "@material-ui/icons/Cancel";
import CompareArrowsIcon from "@material-ui/icons/CompareArrows";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import DnerhsApi, { CancelToken } from "api/DnerhsApi";
import { Link, useParams } from "react-router-dom";
import DeleteDialog from "dialogs/DeleteDialog";
import Alert from "components/Alert";
import history from "utils/History";
import useAuth from "hooks/Auth";
import Roles from "constants/Roles";

import AssignmentIcon from "@material-ui/icons/Assignment";
import VisibilityIcon from "@material-ui/icons/Visibility";

const solicitudes = [
  {
    id: 1,
    carrera: "Carrera 1",
    anhio: 2020,
    plazasSolicitadas: 20,
  },
  {
    id: 2,
    carrera: "Carrera 2",
    anhio: 2020,
    plazasSolicitadas: 30,
  },
  {
    id: 3,
    carrera: "Carrera 3",
    anhio: 2020,
    plazasSolicitadas: 40,
  },
  {
    id: 4,
    carrera: "Carrera 4",
    anhio: 2020,
    plazasSolicitadas: 50,
  },
  {
    id: 5,
    carrera: "Carrera 5",
    anhio: 2020,
    plazasSolicitadas: 60,
  },
  {
    id: 6,
    carrera: "Carrera 6",
    anhio: 2020,
    plazasSolicitadas: 70,
  },
  {
    id: 7,
    carrera: "Carrera 7",
    anhio: 2020,
    plazasSolicitadas: 80,
  },
  {
    id: 8,
    carrera: "Carrera 8",
    anhio: 2020,
    plazasSolicitadas: 90,
  },
  {
    id: 9,
    carrera: "Carrera 9",
    anhio: 2020,
    plazasSolicitadas: 100,
  },
  {
    id: 10,
    carrera: "Carrera 10",
    anhio: 2020,
    plazasSolicitadas: 25,
  },
];

const useStyles = makeStyles((theme) => ({
  title: {
    margin: theme.spacing(3),
  },
  button: {
    margin: theme.spacing(),
  },
  // Sección de filtros
  filtersSection: {
    background: '#f5f5f5',
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2),
    borderBottom: '1px solid #dee2e6',
  },
  // Campo de búsqueda
  searchField: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: 'white',
      borderRadius: 4,
    },
  },
  // Select de estado
  formControl: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: 'white',
      borderRadius: 4,
    },
  },
  // Contador de resultados
  resultsCounter: {
    background: '#007bff',
    color: 'white',
    padding: '6px 12px',
    borderRadius: 4,
    fontSize: '0.875rem',
    fontWeight: 500,
    display: 'inline-block',
    marginTop: theme.spacing(1),
  },
}));

const List = () => {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalElements, setTotalElements] = useState(3);
  const [rows, setRows] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [toDelete, setToDelete] = useState();
  const { userData } = useAuth();
  const params = useParams();
  const [open, setOpen] = useState(false);
  const isAdmin = userData && userData.role.descripcion === Roles.ROLE_DNERHS;
  const [isPostgrado, setIsPostgrado] = useState(false);

  // Estados para filtros
  const [searchTerm, setSearchTerm] = useState("");
  const [estadoFilter, setEstadoFilter] = useState("");

  useEffect(() => {
    const load = () => {
      try {
        loadData({ page, rowsPerPage, search: searchTerm, estado: estadoFilter });
      } catch (error) {
        console.log(error);
      }
    };

    load();
  }, []);

  const loadData = async ({ page = 0, rowsPerPage = 10, search = "", estado = "" }) => {
    let source = CancelToken.source();
    try {
        let url = `/solicitudes-plazas/page?page=${page}&pageSize=${rowsPerPage}&convenioId=${params.convenioId}`;

        // Agregar filtros si existen
        if (search) {
          url += `&search=${encodeURIComponent(search)}`;
        }
        if (estado) {
          url += `&estado=${encodeURIComponent(estado)}`;
        }

        const response = await DnerhsApi(url, {
        cancelToken: source.token,
      });

      console.log("response load data", response);
      const {content : rows, totalElements} = response.data;
      setRows(rows);
      setTotalElements(totalElements);
    } catch (error) {
      console.log(error);
    }
  };

  const handleChangePage = async (event, newPage) => {
    setRows([]);
    try {
      setPage(newPage);
      await loadData({ page: newPage, rowsPerPage, search: searchTerm, estado: estadoFilter });
    } catch (error) {
      console.log(error);
    }
  };

  const handleChangeRowsPerPage = async (event) => {
    let rowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(rowsPerPage);
    setRows([]);

    try {
      await loadData({ page: 0, rowsPerPage, search: searchTerm, estado: estadoFilter });
      setPage(0);
    } catch (error) {
      console.log(error);
    }
  };

  // Handler para búsqueda por texto
  const handleSearchChange = async (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    setPage(0);
    setRows([]);
    try {
      await loadData({ page: 0, rowsPerPage, search: value, estado: estadoFilter });
    } catch (error) {
      console.log(error);
    }
  };

  // Handler para limpiar búsqueda
  const handleClearSearch = async () => {
    setSearchTerm("");
    setPage(0);
    setRows([]);
    try {
      await loadData({ page: 0, rowsPerPage, search: "", estado: estadoFilter });
    } catch (error) {
      console.log(error);
    }
  };

  // Handler para filtro de estado
  const handleEstadoChange = async (event) => {
    const value = event.target.value;
    setEstadoFilter(value);
    setPage(0);
    setRows([]);
    try {
      await loadData({ page: 0, rowsPerPage, search: searchTerm, estado: value });
    } catch (error) {
      console.log(error);
    }
  };

  const deleteOne = async () => {
    let source = CancelToken.source();
    try {
  /*-    let url = `/carreras-programas/${toDelete}`;
      const response = await DnerhsApi.delete(url, {
        cancelToken: source.token,
      });
      console.log("response delete", response); */
        Alert.show({
          message: "Registro eliminado exitosamente.",
          type: "success",
        });
   //     await loadData({ page, rowsPerPage });
    } catch (error) {
      console.log(error);
    }
    setOpenDialog(false);
    setToDelete();
  };

  const handleOpenDialog = (id) => {
    setOpenDialog(true);
    setToDelete(id);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Paper>
          <Box p={1}>
            <Typography
              variant="h5"
              color="primary"
              align="center"
              className={classes.title}
            >
              {`Solicitud de Asignación de Plazas`}
            </Typography>

            {/* Sección de filtros */}
            <Box className={classes.filtersSection}>
              <Grid container spacing={2} alignItems="center">
                {/* Campo de búsqueda */}
                <Grid item xs={12} sm={6} md={8}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Buscar por carrera, establecimiento, región o institución..."
                    value={searchTerm}
                    onChange={handleSearchChange}
                    className={classes.searchField}
                    size="small"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon color="action" />
                        </InputAdornment>
                      ),
                      endAdornment: searchTerm && (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            onClick={handleClearSearch}
                            edge="end"
                          >
                            <ClearIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                {/* Select de estado */}
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl
                    fullWidth
                    variant="outlined"
                    size="small"
                    className={classes.formControl}
                  >
                    <InputLabel>Estado</InputLabel>
                    <Select
                      value={estadoFilter}
                      onChange={handleEstadoChange}
                      label="Estado"
                    >
                      <MenuItem value="">Todos</MenuItem>
                      <MenuItem value="Pendiente">Pendiente</MenuItem>
                      <MenuItem value="Aprobado por DNERHS">Aprobado por DNERHS</MenuItem>
                      <MenuItem value="Rechazado por DNERHS">Rechazado por DNERHS</MenuItem>
                      <MenuItem value="Finalizado">Finalizado</MenuItem>
                      <MenuItem value="Utilizado">Utilizado</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              {/* Contador de resultados */}
              <Box mt={2}>
                <span className={classes.resultsCounter}>
                  {totalElements} {totalElements === 1 ? 'resultado' : 'resultados'}
                </span>
              </Box>
            </Box>

            <Table size="small">
              <TableHead>
                <TableRow>
                  {/* <TableCell align="left">Código</TableCell> */}
                  <TableCell align="center">Nro.</TableCell>

                  <TableCell align="center">Año</TableCell>
                  <TableCell align="left">Carrera / Programa</TableCell>
                  <TableCell align="left">Establecimiento</TableCell>
                  <TableCell align="left">Region Sanitaria</TableCell>
                  <TableCell align="left">Insititución Formadora</TableCell>

                  <TableCell align="left">Plazas solicitadas</TableCell>
                  <TableCell align="left">Estado Solicitud</TableCell>

                  <TableCell align="center">Acción</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, index) => (
                  <TableRow key={index}>
                    {/* <TableCell align="left">{row.id}</TableCell> */}
                    <TableCell align="center">{row.id}</TableCell>

                    <TableCell align="center">{row.anio}</TableCell>
                    <TableCell align="left">{(row.carreraprograma.descripcion==="Postgrado"? ("Postgrado - "+row.nombrePostgrado.descripcion ):(row.carreraprograma.descripcion))}</TableCell>                    
                    <TableCell align="left">{row.datosEstablecimiento.institucionEstablecimiento.nombreServicio.nombre}</TableCell>
                    <TableCell align="left">{row.datosEstablecimiento.regionSanitaria.region}</TableCell>
                    <TableCell align="left">{row.convenio.institucionFormadora.institucion}</TableCell>
                    <TableCell align="left">{row.lugaresSolicitados}</TableCell>
                    <TableCell align="left">{row.estado}</TableCell>
                    
                    <TableCell align="center">
                      {/* {isAdmin && (
                        <Tooltip title={row.estado!='Pendiente'? "Ver":"Asignar"} aria-label="asignar">
                          <IconButton
                            size="small"
                            aria-label="asignar"
                            color="primary"
                            onClick={() => history.push({
                              pathname: `/convenios/asignacionPlazas/solicitudes/crear/${row.id}`,
                              state: {
                                readOnly: true
                              }
                            })}
                          >
                            {row.estado!='Pendiente'? <VisibilityIcon />:<CompareArrowsIcon />}
                          </IconButton>
                        </Tooltip>
                      )} */}
                      
                       {!isAdmin && (
                        <Tooltip title={row.estado!='Rechazado por DNERHS'? "Ver":"Editar"} aria-label="asignar">
                          <IconButton
                            size="small"
                            aria-label="asignar"
                            color="primary"
                            onClick={() => history.push({
                              pathname: `/convenios/asignacionPlazas/solicitudes/ver/${row.id}`,
                              state: {
                                readOnly: true
                              }
                            })}
                          >
                            {row.estado!='Rechazado por DNERHS'? <VisibilityIcon />:<EditIcon />}
                          </IconButton>
                        </Tooltip>
                      )}
                  


                    {isAdmin && (
                      <Tooltip 
                        title={
                          row.estado === 'Aprobado por DNERHS' ? "Editar" : 
                          row.estado === 'Pendiente' ? "Asignar" : "Ver"
                        } 
                        aria-label="accion"
                      >
                        <IconButton
                          size="small"
                          aria-label="accion"
                          color="primary"
                          onClick={() => history.push({
                            pathname: `/convenios/asignacionPlazas/solicitudes/crear/${row.id}`,
                            state: {
                              readOnly: true
                            }
                          })}
                        >
                          {row.estado === 'Aprobado por DNERHS' ? (
                            <EditIcon />
                          ) : row.estado === 'Pendiente' ? (
                            <AssignmentIcon />
                          ) : (
                            <VisibilityIcon />
                          )}
                        </IconButton>
                      </Tooltip>
                    )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[10, 15, 20]}
                    colSpan={3}
                    count={totalElements}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    SelectProps={{
                      inputProps: { "aria-label": "Registros por página" },
                      native: false,
                    }}
                    labelDisplayedRows={({ from, to, count }) =>
                      `${from}-${to} de ${count}`
                    }
                    labelRowsPerPage="Registros por página"
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </TableRow>
              </TableFooter>
            </Table>
            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
            >
              <Grid item className={classes.button}>
                <Button
                  variant="contained"
                  color="default"
                  onClick={() => history.goBack()}
                >
                  Atrás
                </Button>
              </Grid>
              {!isAdmin && (
                <Grid item className={classes.button}>
                  <Link
                    to={`/convenios/asignacionPlazas/solicitudes/crear/${params.convenioId}`}
                  >
                    <Fab color="primary" aria-label="nuevo">
                      <Tooltip title="Nueva carrera" aria-label="nuevo">
                        <AddIcon />
                      </Tooltip>
                    </Fab>
                  </Link>
                </Grid>
              )}
            </Grid>
          </Box>
          <DeleteDialog
            open={openDialog}
            onClose={handleCloseDialog}
            onAccept={deleteOne}
            aria-labelledby="form-dialog-title"
          />
        </Paper>
      </Grid>
    </Grid>
  );
};

export default List;
